import { takeLatest, put, call, select } from 'redux-saga/effects';
import EntityActions, { EntityTypes } from '../Redux/EntityRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * getEntity(api, {uuid, query}) {
    try {
        const response = yield call(api.getEntityResource, uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(EntityActions.fetchEntitySuccess(response.data.data.entity));
    } catch (e) {
        yield put(EntityActions.fetchEntityFailure(e));
    }
}

export function * updateEntity(api, {uuid, entity, query}) {
    try {
        const response = yield call(api.patchEntityResource, uuid, entity, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(EntityActions.updateEntitySuccess(response.data.data.entity));
    } catch (e) {
        yield put(EntityActions.updateEntityFailure(e));
    }
}

export function * watchEntity(api) {
    yield takeLatest(EntityTypes.FETCH_ENTITY, getEntity, api);
    yield takeLatest(EntityTypes.UPDATE_ENTITY, updateEntity, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/EntitySagas.js